import React from "react";
import {
  Footer as SundayFooter,
  ThemeProvider as SundayThemeProvider,
} from "@sunday/component";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { FOOTER_TYPE } from "src/constants/layout";
import { ICTH_THEME } from "src/components/Common/ICTHLayout/constants";
import { buildICTHFooterMenus } from "src/components/Common/ICTHLayout/navigation";
import FooterSimple from "./FooterSimple/FooterSimple";

export interface CustomFooterProps {
  content: any;
  footerType: string;
}

const RetailFooter = ({
  content,
  footerType,
}: CustomFooterProps): JSX.Element => {
  const router = useRouter();
  const { t } = useTranslation("layout");
  const language = router.locale === "en" ? "en" : "th";
  const menus = buildICTHFooterMenus({
    language,
    translate: t,
  });

  switch (footerType) {
    case FOOTER_TYPE.MENU:
      return (
        <SundayThemeProvider theme={ICTH_THEME}>
          <SundayFooter
            menus={menus}
            socials={[]}
            showSocials={false}
            className="icth-footer"
          />
        </SundayThemeProvider>
      );
    case FOOTER_TYPE.LITE:
      return (
        <SundayThemeProvider theme={ICTH_THEME}>
          <SundayFooter
            menus={[]}
            socials={[]}
            showSocials={false}
            className="icth-footer"
          />
        </SundayThemeProvider>
      );
    case FOOTER_TYPE.SIMPLE:
      return <FooterSimple content={content} />;
    default:
      return <></>;
  }
};

export default RetailFooter;
